export default __webpack_public_path__ + "static/media/miscellaneous06.7318e2e7.png";